
// // import React from 'react';
// // import { Link } from 'react-router-dom';
// // import Students from '../assets/students.svg';
// // import { ArrowRightIcon } from '@heroicons/react/24/outline';

// // const HeroSection = () => {
// //   return (
// //     <section className="text-white py-20 px-6 md:px-16">
// //       <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center">
// //         {/* Text Block */}
// //         <div>
// //           <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
// //             Welcome to <span className="text-indigo-400">Isnartech</span> <br />
// //             School ERP Solution
// //           </h1>
// //           <p className="text-gray-300 text-lg mb-8">
// //             Empower your school with AI-driven ERP technology. Streamline daily operations, enhance learning experiences, and connect every stakeholder in one unified platform.
// //           </p>

// //           <div className="flex flex-col sm:flex-row gap-4">
// //             <Link to="/registerSchool">
// //               <button className="bg-indigo-500 hover:bg-indigo-600 text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 transition-all duration-300">
// //                 Start 365-Days Trial
// //                 <ArrowRightIcon className="h-5 w-5" />
// //               </button>
// //             </Link>
// //             <Link to="/features">
// //               <button className="bg-gray-700 hover:bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold">
// //                 Explore Features
// //               </button>
// //             </Link>
// //           </div>
// //         </div>

// //         {/* Illustration */}
// //         <div className="flex justify-center">
// //           <img src={Students} alt="Students" className="max-w-[90%] md:max-w-full" />
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default HeroSection;


// import React from 'react';
// import { Link } from 'react-router-dom';
// import HeroImage from '../assets/4.png'; // updated image import
// import { ArrowRightIcon } from '@heroicons/react/24/outline';

// const HeroSection = () => {
//   return (
//     <section className="relative text-white py-24 px-6 md:px-16 overflow-hidden">
//       <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">

//         {/* Text Block */}
//         <div className="space-y-6">
//           <h1 className="text-5xl md:text-6xl font-extrabold leading-tight tracking-tight">
//             Welcome to <span className="text-indigo-400">Isnartech</span> <br /> 
//             School ERP Solution
//           </h1>

//           <p className="text-gray-300 text-lg max-w-xl">
//             Empower your school with AI-driven ERP technology. Streamline daily operations, enhance learning experiences, and connect every stakeholder in one unified platform.
//           </p>

//           <div className="flex flex-col sm:flex-row gap-5">
//             <Link to="/registerSchool" className="group relative inline-flex items-center overflow-hidden rounded-lg bg-gradient-to-r from-indigo-500 to-indigo-700 px-8 py-3 font-semibold text-white shadow-lg hover:shadow-indigo-600 transition-shadow duration-300">
//               <span className="relative z-10 flex items-center gap-2">
//                 Start 365-Days Trial
//                 <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" />
//               </span>
//               <span className="absolute inset-0 bg-indigo-600 opacity-20 blur-xl rounded-lg"></span>
//             </Link>

//             <Link to="/features" className="inline-block rounded-lg border border-gray-600 px-8 py-3 font-semibold text-gray-300 hover:text-white hover:border-indigo-400 transition-colors duration-300 text-center">
//               Explore Features
//             </Link>
//           </div>
//         </div>

//         {/* Illustration */}
//         <div className="flex justify-center md:justify-end">
//           <img 
//             src={HeroImage} 
//             alt="School ERP Illustration" 
//             className="max-w-full w-[90%] md:w-auto rounded-xl shadow-2xl transform hover:scale-105 transition-transform duration-500 ease-in-out"
//             loading="lazy"
//           />
//         </div>
//       </div>

//       {/* Decorative floating circles for subtle interaction */}
//       <div className="absolute top-10 left-10 w-32 h-32 bg-indigo-600 rounded-full opacity-20 animate-pulse mix-blend-soft-light pointer-events-none"></div>
//       <div className="absolute bottom-20 right-20 w-48 h-48 bg-indigo-500 rounded-full opacity-10 animate-ping mix-blend-soft-light pointer-events-none"></div>
//     </section>
//   );
// };

// export default HeroSection;



// import React from 'react';
// import { Link } from 'react-router-dom';
// import { ArrowRightIcon } from '@heroicons/react/24/outline';
// import FeatureCarouselHero from './FeatureCarousel';

// const HeroSection = () => {
//   return (
//     <section className="relative text-white py-24 px-6 md:px-16 overflow-hidden">
//       <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center">

//         {/* Text Block */}
//         <div className="space-y-6">
//           <h1 className="text-5xl md:text-6xl font-extrabold leading-tight tracking-tight">
//             Welcome to <span className="text-indigo-400">Isnartech</span> <br />
//             School ERP Solution
//           </h1>

//           <p className="text-gray-300 text-lg max-w-xl">
//             Empower your school with AI-driven ERP technology. Streamline daily operations, enhance learning experiences, and connect every stakeholder in one unified platform.
//           </p>

//           <div className="flex flex-col sm:flex-row gap-5">
//             <Link
//               to="/registerSchool"
//               className="group relative inline-flex items-center overflow-hidden rounded-lg bg-gradient-to-r from-indigo-500 to-indigo-700 px-8 py-3 font-semibold text-white shadow-lg hover:shadow-indigo-600 transition-shadow duration-300"
//             >
//               <span className="relative z-10 flex items-center gap-2">
//                 Start 365-Days Trial
//                 <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" />
//               </span>
//               <span className="absolute inset-0 bg-indigo-600 opacity-20 blur-xl rounded-lg"></span>
//             </Link>

//             <Link
//               to="/features"
//               className="inline-block rounded-lg border border-gray-600 px-8 py-3 font-semibold text-gray-300 hover:text-white hover:border-indigo-400 transition-colors duration-300 text-center"
//             >
//               Explore Features
//             </Link>
//           </div>
//         </div>

//         {/* Carousel in place of Image */}
//         <div className="w-full max-w-[550px] mx-auto md:mx-0">
//           <FeatureCarouselHero /> {/* 👇 Custom, smaller version of FeatureCarousel */}
//         </div>
//       </div>

//       {/* Decorative floating circles */}
//       <div className="absolute top-10 left-10 w-32 h-32 bg-indigo-600 rounded-full opacity-20 animate-pulse mix-blend-soft-light pointer-events-none"></div>
//       <div className="absolute bottom-20 right-20 w-48 h-48 bg-indigo-500 rounded-full opacity-10 animate-ping mix-blend-soft-light pointer-events-none"></div>
//     </section>
//   );
// };

// export default HeroSection;

import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import FeatureCarouselHero from './FeatureCarousel'; // Assuming this is the compact version

const HeroSection = () => {
  return (
    <section className="relative text-white py-24 px-6 md:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-16">

        {/* Text Block */}
        <div className="space-y-6">
          <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight leading-snug space-y-2">
            <div>Welcome to</div>
            <div className="text-indigo-400">Isnartech</div>
            <div>School ERP Solution</div>
          </h1>


          <p className="text-gray-300 text-lg max-w-xl">
            Empower your school with AI-driven ERP technology. Streamline daily operations, enhance learning experiences, and connect every stakeholder in one unified platform.
          </p>

          <div className="flex flex-col sm:flex-row gap-5">
            <Link
              to="/registerSchool"
              className="group relative inline-flex items-center overflow-hidden rounded-lg bg-gradient-to-r from-indigo-500 to-indigo-700 px-8 py-3 font-semibold text-white shadow-lg hover:shadow-indigo-600 transition-shadow duration-300"
            >
              <span className="relative z-10 flex items-center gap-2">
                Start 90-Days Trial
                <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" />
              </span>
              <span className="absolute inset-0 bg-indigo-600 opacity-20 blur-xl rounded-lg"></span>
            </Link>

            <Link
              to="/features"
              className="inline-block rounded-lg border border-gray-600 px-8 py-3 font-semibold text-gray-300 hover:text-white hover:border-indigo-400 transition-colors duration-300 text-center"
            >
              Explore Features
            </Link>
          </div>
        </div>

        {/* 🎯 Enhanced Carousel Box */}
        <div className="w-full max-w-[450px] mx-auto md:mx-0">
          <div className="aspect-square rounded-2xl border border-indigo-500/30 shadow-2xl overflow-hidden bg-gradient-to-br from-slate-900 to-slate-800 backdrop-blur-md p-2">
            <FeatureCarouselHero />
          </div>
        </div>
      </div>

      {/* Decorative floating circles */}
      <div className="absolute top-10 left-10 w-32 h-32 bg-indigo-600 rounded-full opacity-20 animate-pulse mix-blend-soft-light pointer-events-none"></div>
      <div className="absolute bottom-20 right-20 w-48 h-48 bg-indigo-500 rounded-full opacity-10 animate-ping mix-blend-soft-light pointer-events-none"></div>
    </section>
  );
};

export default HeroSection;

